/* cSpell:disable */

/*global BMap BMapLib*/
/*global  BMAP_MAPTYPE_CONTROL_MAP BMAP_ANCHOR_TOP_RIGHT BMAP_ANCHOR_BOTTOM_RIGHT INFOBOX_AT_TOP */

import { myMap } from "@/config/";

export const initControl = function () {
    myMap.map.enableScrollWheelZoom();
    // 注册控件
    // 切换卫星地图
    myMap.map.addControl(new BMap.MapTypeControl({
        type: BMAP_MAPTYPE_CONTROL_MAP,
        anchor: BMAP_ANCHOR_TOP_RIGHT,
    }));
    // 放大缩小控件 + -
    myMap.map.addControl(new BMap.NavigationControl({
        anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
        offset: new BMap.Size(10, Math.floor(window.innerHeight / 2 - 50)),
    }));

};